import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, LinearProgress } from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    provider: any;
}

export default function ViewSPHealthScores({
    open,
    onClose,
    setOpen,
    provider
}: ModalProps) {
    if (!provider) return null;

    const healthScores = [
        {
            label: "Booking Frequency",
            value: 92,
            trend: "up",
            trendValue: "4.2",
            description: "High demand with 150+ monthly bookings",
            color: "green",
        },
        {
            label: "Completion Rate",
            value: 88,
            trend: "down",
            trendValue: "2.1",
            description: "88% of accepted jobs completed successfully",
            color: "green",
        },
        {
            label: "Cancellations",
            value: 95,
            trend: "up",
            trendValue: "1.5",
            description: "5% cancellation rate (target <8%)",
            color: "green",
        },
        {
            label: "Customer Ratings",
            value: 96,
            trend: "up",
            trendValue: "0.3",
            description: "Average rating of 4.8/5.0 from 120 reviews",
            color: "green",
        }
    ];

    return (
        <Modal className="modal health_score_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <div className="lt">
                            <h2>{provider.name}</h2>
                            <p>{provider.id} · {provider.type}</p>
                        </div>
                        <button className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="health_summary">
                        <h4>
                            Health Score<span className="score">{provider.health} <i className="arrow">▲</i></span><span className="score_change">2.4 in 30 days</span>
                        </h4>

                        <p>
                            Overall health is excellent. Strong completion rates and positive customer feedback are driving the high score.
                        </p>
                    </div>

                    {/* Content */}
                    <div className="health_score_view">
                        {healthScores.map((item, index) => (
                            <div className="score_row" key={index}>
                                <div className="score_header">
                                    <label>{item.label}</label>

                                    <div className="score_meta">
                                        <span>{item.value}%</span>
                                        <span className={`trend ${item.trend}`}>
                                            {item.trendValue} <i className="arrow">{item.trend === "up" ? "▲" : "▼"}</i>
                                        </span>
                                    </div>
                                </div>

                                <div className="progress_flex">
                                    <p className="score_desc">{item.description}</p>
                                    <LinearProgress
                                        variant="determinate"
                                        value={item.value}
                                        className={`score_bar ${item.color}`}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="recommended_actions">
                        <h4>Recommended Actions</h4>

                        <ul>
                            <li>
                                <EmailOutlinedIcon />
                                Send performance recognition email
                            </li>
                            <li>
                                <FlagOutlinedIcon />
                                Eligible for "Top Rated" badge next month
                            </li>
                            <li>
                                <BlockOutlinedIcon />
                                No restrictions currently required
                            </li>
                        </ul>
                    </div>

                    {/* Footer */}
                    <div className="footer_btn_flex right">
                        <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button className="btn btn_primary">
                            Take Action
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
